export default __webpack_public_path__ + "static/media/Dr._Stephanie_Y._Akoumany_AHV_In_Moms_We_Trust.e4f6a3db.jpg";